<template lang="pug">
  .lg_container
    <global-header></global-header>
    .banner_container
      img(v-if="!websiteInfo.teacherBannerFlag && websiteInfo.teacherBannerUrlList && websiteInfo.teacherBannerUrlList.length > 0" :src="websiteInfo.teacherBannerUrlList[0]")
      img(v-else src="@/assets/banner/teacher_banner.jpg")
    //- 知名欧美外教双师
    .famous_container
      .teacher_head
        .teacher_head_left
          img(src="@/assets/teacher/famous.png")
          p 授课风格深受10W+孩子喜欢
      .famous_main
        .famous_box
          .famous_avatar
            img(src="@/assets/teacher/teacher1.png")
          .famous_info
            .famous_name 好莱坞名师Alex
            .famous_content
              p 曾任教于某知名在线少儿语言教育公司
              p 曾任教于加利福尼亚州著名儿童剧院
              p 曾主演美国《Laid Bare》等多部电影
        .famous_box.right
          .famous_avatar
            img(src="@/assets/teacher/teacher2.png")
          .famous_info
            .famous_name Joshua Ogden-Davis
            .famous_content
              p 9年在华英语线上、线下教学经验
              p 畅销书《与老外做朋友》联合作者
              p 前疯狂英语杂志外籍编辑
              p 知名双语主持人
    //- 教师风采
    .teacher_container(v-if="websiteInfo.teacherList.length > 0")
      .teacher_head
        .teacher_head_left
          img(src="@/assets/teacher/teacher_title.png")
          p 总有一个适合您的孩子
        .teacher_head_right
          .swipe_button(@click="onPrev")
            img(v-if="currentIndex === 0" src="@/assets/teacher/teacher_left.png")
            img(v-else src="@/assets/teacher/teacher_left_hover.png")
          .swipe_button.right(@click="onNext")
            img(v-if="currentIndex === websiteInfo.teacherList.length - 1" src="@/assets/teacher/teacher_right.png")
            img(v-else src="@/assets/teacher/teacher_right_hover.png")
      .teacher_main
        van-swipe(:show-indicators="false" ref="teacher")
          van-swipe-item(v-for="item in websiteInfo.teacherList" :key="item.id")
            .teacher_info
              .teacher_info_left
                img(:src="item.avatarUrl")
              .teacher_info_right
                .teacher_name {{item.realName}}
                  .english_name {{item.englishName}}
                .tag_list
                  .tag_item(v-for="(tag,index) in (item.keyword ? (isArray(item.keyword) ? item.keyword : item.keyword.split(',')) : [])" :key="index")
                    span.scale {{tag}}
            .teacher_describe
              p {{item.intro}}
    <global-footer></global-footer>
</template>

<script>
import { mapGetters } from 'vuex'
import GlobalHeader from '@/components/GlobalHeader'
import GlobalFooter from '@/components/GlobalFooter'
export default {
  name: 'TeacherFaculty',
  components: {
    GlobalHeader,
    GlobalFooter
  },
  computed: {
    ...mapGetters([
      'websiteInfo'
    ])
  },
  data() {
    return {
      // 教师当前索引
      currentIndex: 0
    }
  },
  methods: {
    // 上一页
    onPrev() {
      if (this.currentIndex > 0) {
        this.currentIndex--
        this.$refs.teacher.prev()
      }
    },
    // 下一页
    onNext() {
      if (this.currentIndex < this.websiteInfo.teacherList.length - 1) {
        this.currentIndex++
        this.$refs.teacher.next()
      }
    },
    // 判断是否是数组
    isArray (o) {
      return Object.prototype.toString.call(o) === '[object Array]'
    }
  }
}
</script>

<style lang="scss" scoped>
.lg_container {
  .famous_container {
    padding: 0 32px;
    margin-top: 45px;
    margin-bottom: 30px;
    .teacher_head {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      .teacher_head_left {
        img {
          height: 22px;
        }
        p {
          color: #666666;
        }
      }
    }
    .famous_main {
      padding-top: 20px;
      .famous_box {
        background: #FFFFFF;
        box-shadow: 0px 3px 13px 0px rgba(0, 0, 0, 0.1);
        border-radius: 5px;
        padding: 20px 16px 30px 50px;
        position: relative;
        margin-left: 35px;
        margin-top: 20px;
        &.right {
          padding: 20px 50px 30px 20px;
          margin-left: 0;
          margin-right: 35px;
          .famous_avatar {
            left: auto;
            right: 0;
            transform: translate(50%, -50%);
          }
        }
        .famous_avatar {
          position: absolute;
          top: 50%;
          left: 0;
          transform: translate(-50%, -50%);
          width: 74px;
          height: 74px;
          border-radius: 50%;
          overflow: hidden;
          border: 3px solid #FDE4DA;
          img {
            width: 100%;
            height: 100%;
            display: block;
          }
        }
        .famous_info {
          transform: scale(0.95);
          .famous_name {
            color: #333333;
            font-size: 18px;
            font-weight: bold;
            margin-bottom: 12px;
          }
          .famous_content {
            color: #333333;
            font-size: 10px;
            p {
              line-height: 24px;
            }
          }
        }
      }
    }
  }
  .teacher_container {
    padding: 30px 30px 0;
    position: relative;
    margin: 30px 0 50px;
    &::before {
      content: '';
      display: block;
      width: 350px;
      height: 1px;
      background-color: #E7E7E7;
      position: absolute;
      top: 0;
      left: 12px;
    }
    .teacher_head {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      .teacher_head_left {
        img {
          width: 118px;
          height: 30px;
        }
        p {
          color: #666666;
        }
      }
      .teacher_head_right {
        width: 70px;
        height: 30px;
        border: 1px solid #cccccc;
        border-radius: 15px;
        display: flex;
        align-items: center;
        overflow: hidden;
        .swipe_button {
          display: inline-block;
          width: 35px;
          height: 30px;
          cursor: pointer;
          &.right {
            border-left: 1px solid #ccc;
          }
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    .teacher_main {
      width: 100%;
      background: #FFFFFF;
      box-shadow: 0px 3px 13px 0px rgba(0, 0, 0, 0.1);
      border-radius: 10px;
      margin-top: 30px;
      .teacher_info {
        padding: 20px 10px 20px 14px;
        display: flex;
        .teacher_info_left {
          background: url('~@/assets/teacher/teacher_bg.png') no-repeat center;
          background-size: 112px 107px;
          width: 112px;
          height: 107px;
          text-align: center;
          margin-right: 16px;
          img {
            border-radius: 50%;
            overflow: hidden;
            width: 105px;
            height: 105px;
          }
        }
        .teacher_info_right {
          flex: 1;
          .teacher_name {
            font-size: 16px;
            color: #333333;
            font-weight: bold;
            margin-bottom: 16px;
            .english_name {
              display: inline-block;
              color: #70C76B;
              margin-left: 10px;
            }
          }
          .tag_list {
            .tag_item {
              position: relative;
              color: #333333;
              font-size: 10px;
              padding: 0 2px 0 12px;
              height: 24px;
              line-height: 22px;
              box-sizing: border-box;
              border: 1px solid #cccccc;
              border-radius: 15px;
              margin: 0 4px 4px 0;
              display: inline-block;
              .scale {
                color: #333333;
                font-size: 10px;
                display: inline-block;
                transform: scale(0.85);
              }
              &::before {
                content: '';
                display: inline-block;
                background: url('~@/assets/teacher/teacher_li.png') no-repeat;
                background-size: cover;
                width: 10px;
                height: 11px;
                position: absolute;
                left: 5px;
                top: 50%;
                transform: translateY(-50%);
              }
            }
          }
        }
      }
      .teacher_describe {
        padding: 0 14px 0 20px;
        color: #666666;
        font-size: 14px;
        line-height: 25px;
        margin-top: 5px;
        p {
          padding: 24px 0;
          border-top: 1px solid #E7E7E7;
        }
      }
    }
  }
}
</style>
